import React from "react"
import { IntlProvider } from "react-intl"
import { en, zhCN, zhHK } from "../../languages"

const langObj = {
  en: en,
  "zh-HK": zhHK,
  "zh-CN": zhCN,
}

const IntlWrapper = props => {
  const { pageContext } = props
  const lang = pageContext.langKey || pageContext.baseSlug
  return (
    <IntlProvider messages={langObj[lang]} locale={lang} defaultLocale={lang}>
      {props.children}
    </IntlProvider>
  )
}

export default IntlWrapper
